export default "__VITE_ASSET__YtmkNfgj__"